import React, { PropsWithChildren } from "react";
import clsx from "clsx";

type Props = Readonly<{
  className?: string;
}>;

export const Container: React.FC<PropsWithChildren<Props>> = ({
  className = "",
  children,
}) => <div className={clsx(`container`, className)}>{children}</div>;
